export function LruCache<T>(limit = 5) {
	const cache = new Map<
		string,
		{
			lastAccessed: number;
			value: T;
		}
	>();

	return {
		get: (
			key: string,
		):
			| {
					lastAccessed: number;
					value: T;
			  }
			| undefined => cache.get(key),
		set: (key: string, value: T): void => {
			cache.set(key, { lastAccessed: Date.now(), value });

			if (cache.size <= limit) {
				return;
			}

			// limit the cache size based on the oldest entry based on lastAccessed time
			let oldestKey: string | null = null;
			let oldestLastAccessed: number | null = null;

			for (const [key_, value_] of cache.entries()) {
				if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
					oldestKey = key_;
					oldestLastAccessed = value_.lastAccessed;
				}
			}

			if (oldestKey) {
				cache.delete(oldestKey);
			}
		},
		delete: (key: string): void => {
			cache.delete(key);
		},
		clear: (): void => {
			cache.clear();
		},
	};
}
